import {PayloadAction, createSlice} from "@reduxjs/toolkit";

import {ILocalStockMovement} from "~/model/DAO/IStockMovement";

import {resetAll} from "./global";

export interface StockMovementState {
  localStockMovement: ILocalStockMovement;
  isLocalStockMovementEdited: boolean;
  isSpanishAllergensWarningVisible: boolean;
}

const initialState: StockMovementState = {
  localStockMovement: {} as ILocalStockMovement,
  isLocalStockMovementEdited: false,
  isSpanishAllergensWarningVisible: false,
};

export const LocalStockMovementSlice = createSlice({
  name: "localStockMovement",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    setStockMovement: (state, action: PayloadAction<ILocalStockMovement>) => {
      state.localStockMovement = {
        ...state.localStockMovement,
        ...action.payload,
      };
      state.isLocalStockMovementEdited = true;
    },
    setIsSpanishAllergensWarningVisible: (state, action: PayloadAction<boolean>) => {
      state.isSpanishAllergensWarningVisible = action.payload;
    },
    resetStockMovementItems: (state) => {
      state.localStockMovement.items = [];
      state.localStockMovement.sharedCosts = [];
    },
    resetEdited: (state) => {
      state.isLocalStockMovementEdited = false;
    },
    resetStockMovement: () => initialState,
  },
});

export const LocalStockMovementActions = LocalStockMovementSlice.actions;

export default LocalStockMovementSlice.reducer;
